module.exports = __webpack_public_path__ + "img/2.8af08a4d.png";